import { render } from "./Details.vue?vue&type=template&id=876eb98e"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"

import "./Details.vue?vue&type=style&index=0&id=876eb98e&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/lostsailor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__